import { createContext, useContext, useReducer, ReactNode } from 'react';
import {
  reducer,
  initialState,
  ActivationState,
  ActivationAction,
} from '../../reducers/activationBuilderReducer';

interface ActivationContextProps {
  state: ActivationState;
  dispatch: React.Dispatch<ActivationAction>;
}

const ActivationContext = createContext<ActivationContextProps | undefined>(
  undefined
);

export const ActivationProvider = ({ children }: { children: ReactNode }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <ActivationContext.Provider value={{ state, dispatch }}>
      {children}
    </ActivationContext.Provider>
  );
};

export const useActivation = (): ActivationContextProps => {
  const context = useContext(ActivationContext);
  if (!context) {
    throw new Error('useActivation must be used within an ActivationProvider');
  }
  return context;
};
